import { render } from "./SensorLastMessage.vue?vue&type=template&id=678b9a90&ts=true"
import script from "./SensorLastMessage.vue?vue&type=script&lang=ts"
export * from "./SensorLastMessage.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__